import React from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useGoToSubscription} from "../GoToSubscription";
import {BottomNavigation, BottomNavigationAction, useMediaQuery} from "@mui/material";
import json2mq from "json2mq";

const BottomMenu = ({tabs, handleLoginClick}) => {
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const goToSubscription = useGoToSubscription();
    const location = useLocation();
    const loc = location.pathname;
    const navigate = useNavigate();
    const handleClick = async (e, tab) => {
        await goToSubscription();
    };

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    return (
        <>
            {mediaQueryVar === false && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0",
                        backgroundColor: "white",
                        width: "105%",
                        zIndex: "100",
                        marginLeft: "-10px",
                    }}
                >
                    <BottomNavigation showLabels>
                        <BottomNavigationAction
                            label= {tabs[0].label}
                            onClick={() => navigate(tabs[0].href)}
                            icon={
                                <img
                                    src={
                                        loc === tabs[0].href
                                            ? "/images/dashboardS.svg"
                                            : "/images/dashboardU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label={tabs[1].label}
                            onClick={() => {
                                navigate(
                                    tabs[1].href
                                );
                            }}
                            icon={
                                <img
                                    src={
                                        loc == tabs[1].href
                                            ? "/images/portfolioS.svg"
                                            : "/images/portfolioU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label={tabs[2].label}
                            onClick={() => handleClick()}
                            icon={
                                <img
                                    src={
                                        loc === tabs[2].href
                                            ? "/images/dollarS.svg"
                                            : "/images/dollarU.svg"
                                    }
                                    width={24}
                                    height={24}
                                    alt="Icon"
                                    style={{marginBottom: "-3px"}}
                                />
                            }
                        />
                    </BottomNavigation>
                </div>
            )}
        </>
    );
};

export default BottomMenu;
